import type { Provider } from "../types";

/**
 * Async function that resolves with MetaMask/Coinbase provider if installed
 *
 * window.ethereum === await getInjectedProvider()
 */
const getInjectedProvider = async ({
  timeout = 1000,
}: {
  timeout?: number;
} = {}): Promise<Provider | null> => {
  const ETHEREUM_INIT = "ethereum#initialized";
  let handled = false;

  return new Promise((resolve) => {
    // Event handler to fire once provider is initialized
    const handleProvider = () => {
      // In case event handler wasn't removed properly, don't run twice
      if (handled) return;
      handled = true;

      window.removeEventListener(ETHEREUM_INIT, handleProvider);
      const { ethereum } = window as Window;
      if (ethereum) {
        resolve(ethereum as Provider);
      } else {
        resolve(null);
      }
    };

    if ((window as Window).ethereum) {
      // Check provider if we have it immediately
      handleProvider();
    } else {
      // Otherwise set up listener to let extension finish loading
      window.addEventListener(ETHEREUM_INIT, handleProvider, { once: true });

      // And run again after a delay in case provider doesn't fire standard event
      setTimeout(() => {
        handleProvider();
      }, timeout);
    }
  });
};

export { getInjectedProvider };
